import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import cronLogo from '../assets/cron-labs-logo.jpeg';

const API_URL = process.env.REACT_APP_API_ENDPOINT;

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await axios.post(`${API_URL}/api/accounts/login/`, {
        username,
        password,
      });
      const { access_token, role, user_id, reporting_manager_id, role_id } = res.data;
      localStorage.setItem('access_token', access_token);
      localStorage.setItem('role', role);
      localStorage.setItem('role_id', role_id);
      localStorage.setItem('user_id', user_id); // use the username from the form
      localStorage.setItem('reporting_manager', reporting_manager_id);
      onLogin();
      navigate('/');
    } catch (err) {
      console.error(err);
      setError('Invalid credentials or server error.');
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50">
      <img src={cronLogo} alt="Logo" className="w-10 mb-4 mt-4" />
      <form
        className="bg-white rounded-xl shadow p-8 w-full max-w-md flex flex-col gap-4"
        onSubmit={handleSubmit}
      >
        <h2 className="text-xl font-bold mb-2 text-center">Sign in to your account</h2>
        <div>
          <label className="block font-semibold mb-1">Email</label>
          <input
            type="text"
            className="border rounded px-3 py-2 w-full"
            placeholder="Enter your username"
            value={username}
            onChange={e => setUsername(e.target.value)}
            required
          />
        </div>
        <div>
          <label className="block font-semibold mb-1">Password</label>
          <input
            type="password"
            className="border rounded px-3 py-2 w-full"
            placeholder="********"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
        </div>
        <div 
          onClick={() => navigate('/forgot-password')}
          className="text-right text-xs text-indigo-600 hover:underline cursor-pointer select-none mb-2"
        >
          Forgot password?
        </div>
        {error && <div className="text-red-500 text-sm text-center">{error}</div>}
        <button
          type="submit"
          className="bg-indigo-600 text-white rounded px-6 py-2 w-full mt-2 font-semibold disabled:opacity-60"
          disabled={loading}
        >
          {loading ? 'Signing in...' : 'Sign in'}
        </button>
      </form>
    </div>
  );
};

export default Login;
